import get from 'transmute/get';
export const getZorseInbox = get('zorseInboxes');